import { lazy } from 'react'

export const RatingPage = lazy(() => import('./RatingPage'))
